import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { createRequestId } from '../../shared/utils/request-id.util';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { OrderRefusalPreview, OrderRefusalRequest, OrderRefusalService } from './order-refusal.service';

@Component({
  selector: 'app-order-refusal-dialog',
  templateUrl: './order-refusal-dialog.component.html',
  styleUrls: ['./order-refusal-dialog.component.scss']
})
export class OrderRefusalDialogComponent implements OnInit {
  customerAccountManaged = false;
  preview?: OrderRefusalPreview;
  reason = new UntypedFormControl('', [Validators.required, Validators.maxLength(500)]);
  loading = false;
  saving = false;
  changed = false;
  uncertain = false;
  error = '';
  invoiceId?: number;
  accountInvoiceId = 0;
  private sent?: OrderRefusalRequest;

  constructor(private service: OrderRefusalService, private router: Router,
    public ref: MatDialogRef<OrderRefusalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { orderId: number }) {}

  ngOnInit() { void this.load(); }
  async load() {
    if (this.saving || this.loading || this.uncertain) return;
    this.loading = true;
    this.error = '';
    try {
      this.preview = await firstValueFrom(this.service.preview(this.data.orderId));
      this.accountInvoiceId = this.preview.invoices[0]?.id || 0;
      if (!this.reason.value) this.reason.setValue(this.preview.reason || 'Отказ клиента');
      this.invoiceId = this.preview.invoices.find(invoice => invoice.id === this.invoiceId && invoice.available_refund_after > 0.009)?.id
        || this.preview.invoices.find(invoice => invoice.available_refund_after > 0.009)?.id;
      this.sent = undefined;
    } catch (error) { this.error = extractApiErrorMessage((error as any)?.error || error, 'Не удалось получить расчёт'); }
    finally { this.loading = false; }
  }
  get refundableInvoices() { return (this.preview?.invoices || []).filter(row => row.available_refund_after > 0.009); }
  get selectedInvoice() { return this.preview?.invoices.find(row => row.id === this.invoiceId); }
  get canConfirm() {
    return this.preview && !this.preview.blocked_reason && this.preview.needs_confirmation &&
      this.reason.valid && String(this.reason.value || '').trim() && !this.loading && !this.saving;
  }
  async confirm(goToRefund: boolean) {
    if (!this.canConfirm) return;
    this.sent = this.sent || { request_id: createRequestId(), expected_version: this.preview!.version,
      reason: String(this.reason.value).trim() };
    this.saving = true;
    this.error = '';
    this.ref.disableClose = true;
    try {
      await firstValueFrom(this.service.apply(this.data.orderId, this.sent));
      this.changed = true;
      this.uncertain = false;
      this.saving = false;
      await this.load();
      if (goToRefund && this.invoiceId && !this.error) this.openRefund();
    } catch (error) {
      const status = Number((error as any)?.status || 0);
      this.uncertain = status === 0 || status >= 500;
      if (!this.uncertain) this.sent = undefined;
      this.error = this.uncertain ? 'Подтверждение не получено. Нажмите «Проверить отказ» для безопасного повтора.'
        : extractApiErrorMessage((error as any)?.error || error, 'Не удалось оформить отказ');
    } finally { this.saving = false; this.ref.disableClose = false; }
  }
  openRefund() {
    if (!this.invoiceId || this.preview?.needs_confirmation || this.preview?.blocked_reason || this.saving) return;
    this.ref.close(this.changed);
    void this.router.navigate(['/docs/client_invoice_refund/create'], {
      queryParams: { invoice_id: this.invoiceId, order_refusal: this.data.orderId }
    });
  }
  openHistory() {
    this.ref.close(this.changed);
    void this.router.navigate(['/docs/client_invoice_refund/list'], { queryParams: { order_id: this.data.orderId } });
  }
}
